import request from '@/utils/httpRequest'

export default class budgetService {
    viewBudget(id) {
        return request({
            url: '/budget/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }

    viewBudgetAdjust(id) {
        return request({
            url: '/budgetAdjust/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }
    // 预算名称查询
    getBudgetName(id) {
        return request({
            url: '/budget/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }
    viewSupplierBudget(id) {
        return request({
            url: '/supplierBudget/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }
    viewSupplierBudgetAdjust(id) {
        return request({
            url: '/supplierBudgetAdjust/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }
}
